/* eslint-disable import/prefer-default-export */
import { ohsListParamKeys, OhsListParams, ParamTypes } from '../OhsRegisterModels';

// removes all params included in filter model
export const resetFilter = (params: URLSearchParams) => {
  const objParam: Record<string, string> = Object.fromEntries(params.entries());
  const IGNORED_KEYS = [ParamTypes.Tab, ParamTypes.FolderView];

  const newFilter = Object.fromEntries(
    Object.entries(objParam).filter(
      ([key]) =>
        !ohsListParamKeys.includes(key as keyof OhsListParams) ||
        IGNORED_KEYS.includes(key as keyof OhsListParams)
    )
  );

  return newFilter;
};
